import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useUser } from '../lib/UserContext';
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import '../css/Login.css';

function Login() {
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [userData, setUserData] = useState(null);
  const { login, isAuthenticated } = useUser();
  const navigate = useNavigate();
  const apiUrl = process.env.REACT_APP_API_URL;

  const maskPassword = (value) => {
    if (!value) return '';
    if (value.length <= 3) return value;
    return `${'*'.repeat(value.length - 3)}${value.slice(-3)}`;
  };

  // Cargar datos temporales del usuario desde sessionStorage
  useEffect(() => {
    const tempData = sessionStorage.getItem('tempUserData');
    if (!tempData) {
      // Si no hay datos temporales, redirigir a ofrendas
      navigate('/ofrendas');
      return;
    }
    
    try {
      const user = JSON.parse(tempData);
      setUserData(user);
      console.log('Usuario cargado para login:', user);
    } catch (error) {
      console.error('Error al parsear datos temporales:', error);
      navigate('/ofrendas');
    }
  }, [navigate]);

  // Si ya está autenticado, redirigir a opciones
  useEffect(() => {
    if (isAuthenticated()) {
      navigate('/opciones');
    }
  }, [isAuthenticated, navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!password) {
      toast.error('Por favor ingrese su contraseña');
      return;
    }

    if (!userData) {
      toast.error('Error: datos de usuario no disponibles');
      navigate('/ofrendas');
      return;
    }

    setLoading(true);
    console.log('🚀 INICIANDO LOGIN - userData:', userData);
    console.log('🔑 Password ingresada (longitud):', password.length);
    console.log('🔑 Password enmascarada:', maskPassword(password));
    console.log('🌐 API URL:', apiUrl);

    try {
      console.log('🔐 Intentando login con contraseña...');
      console.log('Identificación:', userData.identificacion);
      
      const requestData = {
        Identificacion: userData.identificacion,  // Mayúscula para coincidir con el backend
        Password: password  // Mayúscula para coincidir con el backend
      };

      const requestDataLog = {
        ...requestData,
        Password: maskPassword(requestData.Password)
      };
      
      console.log('📤 Enviando al backend:', JSON.stringify(requestDataLog));
      
      // Llamar al endpoint de login con contraseña
      const response = await axios.post(`${apiUrl}/Donantes/login`, requestData);

      console.log('✅ Login exitoso:', response.data);
      
      // Limpiar datos temporales
      sessionStorage.removeItem('tempUserData');
      
      // Verificar si debe cambiar contraseña
      if (response.data.cambioHash === 'S') {
        console.log('⚠️ Usuario debe cambiar contraseña');
        // Guardar datos para cambio de contraseña
        sessionStorage.setItem('cambioPasswordData', JSON.stringify(response.data));
        navigate('/cambiar-password');
        return;
      }
      
      // Establecer el usuario en el contexto
      login(response.data);
      
      toast.success(`Bienvenido ${response.data.nombres} ${response.data.apellidos}`);
      
      // Redirigir a opciones
      setTimeout(() => {
        navigate('/opciones');
      }, 500);

    } catch (error) {
      console.error('❌ ERROR al iniciar sesión:', {
        message: error?.message,
        status: error?.response?.status,
        data: error?.response?.data
      });
      console.error('❌ error.response:', error?.response);
      console.error('❌ error.response.data:', error?.response?.data);
      console.error('❌ error.message:', error?.message);
      
      if (error?.response?.status === 401) {
        toast.error(error.response.data?.mensaje || 'Contraseña incorrecta');
      } else if (error?.response?.status === 404) {
        toast.error('Usuario no encontrado');
      } else if (error?.response?.status === 400) {
        toast.error(error.response.data?.mensaje || 'Datos inválidos');
      } else {
        toast.error('Error al iniciar sesión. Intente nuevamente.');
      }
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    // Limpiar datos temporales y volver a ofrendas
    sessionStorage.removeItem('tempUserData');
    navigate('/ofrendas');
  };

  if (!userData) {
    return null; // O un loading spinner
  }

  return (
    <div className="login-container">
      <ToastContainer position="top-right" autoClose={3000} />
      
      <div className="login-card">
        <div className="login-header">
          <i className="fas fa-church login-icon"></i>
          <h1>Beraca Worship</h1>
          <p>Autenticación de Usuario</p>
        </div>

        <div className="user-info" style={{
          backgroundColor: '#f8f9fa',
          padding: '1rem',
          borderRadius: '8px',
          marginBottom: '1.5rem',
          border: '1px solid #dee2e6'
        }}>
          <p style={{ margin: '0.5rem 0' }}>
            <strong>Usuario:</strong> {userData.nombres} {userData.apellidos}
          </p>
          <p style={{ margin: '0.5rem 0' }}>
            <strong>Rol:</strong> {userData.rol?.rol || userData.rol}
          </p>
        </div>

        <form className="login-form" onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="password">
              <i className="fas fa-lock"></i> Contraseña
            </label>
            <input
              type="password"
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Ingrese su contraseña"
              required
              autoFocus
              disabled={loading}
            />
          </div>

          <div style={{ display: 'flex', gap: '1rem', marginTop: '1.5rem' }}>
            <button 
              type="submit" 
              className="btn-login"
              style={{ flex: 1 }}
              disabled={loading}
            >
              {loading ? (
                <>
                  <i className="fas fa-spinner fa-spin"></i> Validando...
                </>
              ) : (
                <>
                  <i className="fas fa-sign-in-alt"></i> Ingresar
                </>
              )}
            </button>

            <button 
              type="button" 
              className="btn-secondary"
              style={{ 
                flex: 1,
                padding: '0.75rem',
                backgroundColor: '#6c757d',
                color: 'white',
                border: 'none',
                borderRadius: '4px',
                cursor: 'pointer',
                fontSize: '1rem'
              }}
              onClick={handleCancel}
              disabled={loading}
            >
              <i className="fas fa-times"></i> Cancelar
            </button>
          </div>
        </form>

        <div className="login-footer">
          <p>
            <i className="fas fa-info-circle"></i> Si olvidó su contraseña, contacte al administrador
          </p>
        </div>
      </div>
    </div>
  );
}

export default Login;
